import React from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { DealDetail, AuthorisedUser, DealActions, DealStatus, DealEvent } from 'api'
import { createAuthorisedUserSelector } from 'selectors/connectionSelectors'
import { LockWrapper, LockButton, LockIcon, LockedUser } from 'view/shared/datagrid'
import { Locale, Translation } from 'locale'
import { getUserFullName, getUserInitials } from 'model'
import { Tooltip } from 'view/components/tooltip'
import { rfqIconSet } from 'view/routes/requests/shared/rfqIconSet'

export interface MidTradeEventLockRendererProps {
  dealDetail: DealDetail
  authorisedUser: AuthorisedUser
  onLock: (dealId: string) => unknown
  onUnlock: (dealId: string) => unknown
}

const mapStateToProps = createStructuredSelector({
  authorisedUser: createAuthorisedUserSelector()
})

const mapDispatchToProps = {
  onLock: DealActions.servicingResponderLock,
  onUnlock: DealActions.servicingResponderUnlock
}

export const MidTradeEventLockRendererComponent: React.FunctionComponent<MidTradeEventLockRendererProps> = props => {
  const {
    dealDetail: { deal, userWithServicingLock, availableEvents },
    authorisedUser,
    onLock,
    onUnlock
  } = props

  const isUserWithLock = userWithServicingLock ? userWithServicingLock.id === authorisedUser.id : true

  const handleLock = () => {
    if (availableEvents.includes(DealEvent.SERVICING_RESPONDER_LOCK) && !userWithServicingLock) {
      onLock(deal.dealId)
    } else if (availableEvents.includes(DealEvent.SERVICING_RESPONDER_UNLOCK) && isUserWithLock) {
      onUnlock(deal.dealId)
    }
  }

  return (
    <LockWrapper>
      <Tooltip
        tooltip={userWithServicingLock ? Locale.translate(Translation.SC_LOCKED_TO, { user: getUserFullName(userWithServicingLock) }) : ''}>
        {/* Need to wrap children in div in order to show tooltip when children is disabled */}
        <div>
          <LockButton
            isLocked={!!userWithServicingLock}
            onClick={handleLock}
            disabled={!isUserWithLock || deal.status === DealStatus.SERVICING_WITH_INITIATOR}
            dataTestId="LockButton">
            <LockIcon>{rfqIconSet.lock}</LockIcon>
            <LockedUser>{userWithServicingLock && getUserInitials(userWithServicingLock)}</LockedUser>
          </LockButton>
        </div>
      </Tooltip>
    </LockWrapper>
  )
}

export const MidTradeEventLockRenderer = connect(mapStateToProps, mapDispatchToProps)(MidTradeEventLockRendererComponent)
